import { Navigate, useLocation, useMatch } from 'react-router-dom'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { Alert } from 'reactstrap'
import { SEARCH_QUERY } from '../../graphql.js'

export const SEARCH = gql(SEARCH_QUERY)

export default function Search() {
  const location = useLocation()
  const match = useMatch('/search/:id')

  console.log('Search rendered', match, location)

  const { loading, error, data } = useQuery(SEARCH, { variables: { id: match.params.id } })

  if (match && match.params.id) {
    if (loading) return <Spinner />
    if (error) {
      console.log(`Search error: ${error.message}`)
      return <Alert className="search-alert" color="danger">{error.message}</Alert>
    }
    if (data && data.search) {
      console.log('Search data: ', data)
      // eslint-disable-next-line react-hooks/rules-of-hooks
      if (data.search.hasPrompts === 'N' || (data.search.hasPrompts && data.search.inputs)) {
        return <Navigate to={`/searchResults/${match.params.id}${location.search}`} replace={true} />
      } else {
        return <Navigate to={`/searchForm/${match.params.id}${location.search}`} replace={true} />
      }
    }

  }
  return <Navigate to="/home" />
}